import React, { useContext } from "react";
import { Flex, Separator } from "@radix-ui/themes";
import CreateBaseView from "components/CreateBaseView";
import SideBar from "components/SideBar";
import { SideBarActiveContext } from "context/SideBarActiveContext";
import LibraryView from "components/LibraryView";

const Dashboard = () => {
  const { currentSideBarActive } = useContext(SideBarActiveContext);
  return (
    <>
      {/* // Subtract 50px because that is the height of the NavBar component. */}
      <div style={{ display: "flex", minHeight: "calc(100vh - 50px)" }}>
        <Flex style={{ flex: 2 }}>
          <SideBar />
        </Flex>
        <Separator
          orientation="vertical"
          style={{ height: "auto" }}
        ></Separator>
        <Flex style={{ flex: 8 }}>
          {currentSideBarActive === "create" && <CreateBaseView />}
          {currentSideBarActive === "lib" && <LibraryView />}
        </Flex>
      </div>
    </>
  );
};

export default Dashboard;
